module.exports = __webpack_public_path__ + "img/p6-1.c937b67d.png";